import { useEffect, useRef, useState } from "react";
import LoginBoard from "./components/LoginBoard";
import LoginMain from "./components/LoginMain";
import SignupForm from "./components/SignupForm";
import { CSSTransition } from "react-transition-group";
import styles from "./css/transitions.module.css";
import { verifyEmailLink } from "../../api/firebase";
import { useUIContext } from "../../context/UIContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Login() {
  const { t } = useTranslation();
  const [openSignup, setOpenSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    schoolid: "",
    password: "",
    fullname: "",
    username: "",
    gender: "남",
    birthday: "",
    mobile: "",
    terms_accepted: false,
    role: "parent",
  });

  const [verifiedEmail, setVerifiedEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState(null);

  // Refs for nodeRef
  const signupRef = useRef(null);
  const loginRef = useRef(null);

  const { setIsLoadingModal } = useUIContext();
  const navigate = useNavigate();

  const handleSignUp = (e) => {
    e.preventDefault();
    setOpenSignup(!openSignup);

    setVerifiedEmail("");

    const urlParams = new URLSearchParams(window.location.search);
    const isVerificationLink =
      urlParams.has("mode") && urlParams.has("oobCode");

    if (isVerificationLink && openSignup) {
      navigate("/login");
    }
  };

  const transitionProps = {
    timeout: 300,
    classNames: {
      enter: styles["fade-enter"],
      enterActive: styles["fade-enter-active"],
      exit: styles["fade-exit"],
      exitActive: styles["fade-exit-active"],
    },
    unmountOnExit: true,
  };

  // URL에서 인증 여부 확인
  useEffect(() => {
    if (isVerified) return;
    const url = window.location.href;

    // URL이 인증 링크인지 확인
    const urlParams = new URLSearchParams(window.location.search);
    const isVerificationLink =
      urlParams.has("mode") && urlParams.has("oobCode");

    if (isVerificationLink) {
      // 인증 링크가 맞다면 verifyEmailLink 실행

      setOpenSignup(true);
      setIsLoadingModal(true);
      // verifiedEmail은 인증 성공 후 이메일이 확인된 경우에만 설정
      verifyEmailLink(url)
        .then((result) => {
          const email = result.user?.email;
          if (email) {
            setIsVerified(true);
            // formData 먼저 설정 후, 약간의 딜레이 후 verifiedEmail 설정
            setFormData((prev) => ({
              ...prev,
              email: email,
              username: email,
            }));
            // formData가 반영된 후 verifiedEmail 설정 (UI 동기화)
            setTimeout(() => {
              setVerifiedEmail(email);
              setIsLoadingModal(false);
            }, 100);
            console.log("인증 성공:", email);
          } else {
            // 이메일이 없으면 인증 실패 처리
            console.error("인증 결과에 이메일이 없습니다.");
            setVerifiedEmail("");
            setIsLoadingModal(false);
            alert("이메일 인증에 실패했습니다. 다시 시도해 주세요.");
          }
        })
        .catch((error) => {
          setError(
            error.message || t("common.commonPages.emailVerificationFailed")
          );
          console.error("인증 실패:", error);
          setVerifiedEmail("");
          setIsLoadingModal(false);
          alert(t("common.login.emailVerificationFailed2"));
        });
    } else {
      setVerifiedEmail("");
      setOpenSignup(false);
      console.log("이 URL은 인증 링크가 아닙니다.");
    }
  }, [setIsLoadingModal, isVerified, t]);

  return (
    <div
      style={{ height: "700px", width: "100%" }}
      className="d-flex justify-content-center align-items-center"
    >
      {/* {isVerified && console.log("isVerified", isVerified)} */}
      {error && console.log("error", error)}
      <div
        style={{
          height: "700px",
          maxWidth: "1000px",
          width: "100%",
        }}
        className="d-flex justify-content-space-between flex-wrap login align-items-center"
      >
        <div
          className="col-sm-7"
          style={{
            position: "relative",
          }}
        >
          {/* <CSSTransition in={!openSignup} {...transitionProps}> */}
          <LoginBoard />
          {/* </CSSTransition> */}
        </div>
        <div className="col-sm-5">
          <CSSTransition
            in={openSignup}
            {...transitionProps}
            nodeRef={signupRef}
          >
            <div ref={signupRef}>
              <SignupForm
                handleSignUp={handleSignUp}
                formData={formData}
                setFormData={setFormData}
                verifiedEmail={verifiedEmail}
              />
            </div>
          </CSSTransition>

          <CSSTransition
            in={!openSignup}
            {...transitionProps}
            nodeRef={loginRef}
          >
            <div ref={loginRef}>
              <LoginMain handleSignUp={handleSignUp} />
            </div>
          </CSSTransition>

          {/* {!openSignup && <LoginMain handleSignUp={handleSignUp} />} */}

          {/* {openSignup ? (
            <SignupForm setOpenSignup={setOpenSignup} />
          ) : (
            <LoginMain setOpenSignup={setOpenSignup} />
          )} */}
        </div>
      </div>
    </div>
  );
}

export default Login;
